import { useLanguage } from '../context/LanguageContext';

const Terms = () => {
  const { language } = useLanguage();

  const content = {
    pl: {
      title: "Regulamin Sklepu",
      lastUpdate: "Ostatnia aktualizacja: Kwiecień 2026",
      sections: [
        {
          title: "1. Dane Sprzedawcy",
          text: "Sklep internetowy SPRZĘT PRO prowadzony jest przez:\n\nPro_Poziom\nul. Sprawna 7F/24\n03-147 Warszawa\n\nNIP: 5242996750\nREGON: 527580660\n\nKontakt:\nE-mail: propoziom@gmail.com\nTelefon: +48 735 598 146\nTelefon: +48 690 284 078"
        },
        {
          title: "2. Postanowienia ogólne",
          text: "Niniejszy regulamin określa zasady korzystania ze sklepu internetowego SPRZĘT PRO dostępnego pod adresem sprzetpro.pl. Sklep prowadzi sprzedaż akumulatorów, baterii i narzędzi dla profesjonalistów."
        },
        {
          title: "3. Definicje",
          text: "Sklep - sklep internetowy SPRZĘT PRO. Klient - osoba fizyczna, prawna lub jednostka organizacyjna dokonująca zakupów w Sklepie. Zamówienie - oświadczenie woli Klienta zmierzające do zawarcia umowy sprzedaży."
        },
        {
          title: "4. Składanie zamówień",
          text: "Zamówienia można składać 24 godziny na dobę, 7 dni w tygodniu. Zamówienie zostaje przyjęte do realizacji po potwierdzeniu przez Sklep. Klient może dokonać zakupu bez rejestracji (jako gość) lub po założeniu konta."
        },
        {
          title: "5. Ceny i płatności",
          text: "Wszystkie ceny podane w Sklepie są cenami brutto (zawierają VAT) i wyrażone są w złotych polskich (PLN). Dostępne metody płatności: PayU (BLIK, karta, przelew), płatność przy odbiorze."
        },
        {
          title: "6. Dostawa",
          text: "Dostawa realizowana jest na terenie Polski. Dostępne metody dostawy: InPost Paczkomat, kurier DPD, punkt odbioru DPD. Czas realizacji zamówienia: 1-3 dni robocze. Darmowa dostawa przy zamówieniach powyżej 500 zł."
        },
        {
          title: "7. Prawo odstąpienia od umowy",
          text: "Klient będący konsumentem ma prawo odstąpić od umowy w terminie 14 dni bez podania przyczyny. Aby skorzystać z prawa odstąpienia, należy poinformować Sklep o swojej decyzji. Zwrot płatności nastąpi w ciągu 14 dni od otrzymania zwrotu towaru."
        },
        {
          title: "8. Reklamacje i gwarancja",
          text: "Produkty objęte są gwarancją producenta. W przypadku wad towaru Klient może złożyć reklamację. Reklamacje rozpatrywane są w terminie 14 dni. Kontakt w sprawie reklamacji: propoziom@gmail.com"
        },
        {
          title: "9. Odpowiedzialność",
          text: "Sklep dokłada wszelkich starań, aby opisy produktów były zgodne z rzeczywistością. Zdjęcia produktów mają charakter poglądowy. Sklep nie ponosi odpowiedzialności za nieprawidłowe użytkowanie produktów."
        },
        {
          title: "10. Ochrona danych osobowych",
          text: "Dane osobowe Klientów przetwarzane są zgodnie z Polityką Prywatności dostępną na stronie Sklepu oraz zgodnie z RODO."
        },
        {
          title: "11. Postanowienia końcowe",
          text: "Sklep zastrzega sobie prawo do zmiany regulaminu. O zmianach Klienci zostaną poinformowani na stronie Sklepu. W sprawach nieuregulowanych niniejszym regulaminem zastosowanie mają przepisy prawa polskiego."
        }
      ]
    },
    ru: {
      title: "Правила магазина",
      lastUpdate: "Последнее обновление: Апрель 2026",
      sections: [
        {
          title: "1. Данные Продавца",
          text: "Интернет-магазин SPRZĘT PRO управляется:\n\nPro_Poziom\nул. Sprawna 7F/24\n03-147 Варшава, Польша\n\nNIP: 5242996750\nREGON: 527580660\n\nКонтакт:\nE-mail: propoziom@gmail.com\nТелефон: +48 735 598 146\nТелефон: +48 690 284 078"
        },
        {
          title: "2. Общие положения",
          text: "Настоящие правила определяют условия использования интернет-магазина SPRZĘT PRO, доступного по адресу sprzetpro.pl. Магазин осуществляет продажу аккумуляторов, батарей и инструментов для профессионалов."
        },
        {
          title: "3. Определения",
          text: "Магазин - интернет-магазин SPRZĘT PRO. Клиент - физическое, юридическое лицо или организационная единица, совершающая покупки в Магазине. Заказ - волеизъявление Клиента, направленное на заключение договора купли-продажи."
        },
        {
          title: "4. Оформление заказов",
          text: "Заказы можно оформлять 24 часа в сутки, 7 дней в неделю. Заказ принимается к выполнению после подтверждения Магазином. Клиент может совершить покупку без регистрации (как гость) или после создания аккаунта."
        },
        {
          title: "5. Цены и оплата",
          text: "Все цены в Магазине являются ценами брутто (включают НДС) и выражены в польских злотых (PLN). Доступные способы оплаты: PayU (BLIK, карта, перевод), оплата при получении."
        },
        {
          title: "6. Доставка",
          text: "Доставка осуществляется по территории Польши. Доступные способы доставки: InPost Paczkomat, курьер DPD, пункт выдачи DPD. Срок выполнения заказа: 1-3 рабочих дня. Бесплатная доставка при заказе от 500 zł."
        },
        {
          title: "7. Право отказа от договора",
          text: "Клиент-потребитель имеет право отказаться от договора в течение 14 дней без указания причины. Для использования права отказа необходимо уведомить Магазин о своём решении. Возврат средств производится в течение 14 дней с момента получения возвращённого товара."
        },
        {
          title: "8. Рекламации и гарантия",
          text: "На товары распространяется гарантия производителя. В случае дефектов товара Клиент может подать рекламацию. Рекламации рассматриваются в течение 14 дней. Контакт по вопросам рекламаций: propoziom@gmail.com"
        },
        {
          title: "9. Ответственность",
          text: "Магазин прилагает все усилия, чтобы описания товаров соответствовали действительности. Фотографии товаров носят иллюстративный характер. Магазин не несёт ответственности за неправильное использование товаров."
        },
        {
          title: "10. Защита персональных данных",
          text: "Персональные данные Клиентов обрабатываются в соответствии с Политикой конфиденциальности, доступной на сайте Магазина, и в соответствии с GDPR."
        },
        {
          title: "11. Заключительные положения",
          text: "Магазин оставляет за собой право изменять правила. Об изменениях Клиенты будут уведомлены на сайте Магазина. В вопросах, не урегулированных настоящими правилами, применяются нормы польского права."
        }
      ]
    }
  };

  const t = content[language] || content.pl;

  return (
    <div className="min-h-screen py-16" data-testid="terms-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl sm:text-5xl uppercase text-white mb-4">
          {t.title}
        </h1>
        <p className="text-zinc-500 mb-8">{t.lastUpdate}</p>

        <div className="space-y-8">
          {t.sections.map((section, index) => (
            <div key={index} className="border border-zinc-800 bg-[#111111] p-6">
              <h2 className="font-heading text-xl uppercase text-yellow-400 mb-3">
                {section.title}
              </h2>
              <p className="text-zinc-300 leading-relaxed whitespace-pre-line">
                {section.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Terms;
